const en = {
	dataMonitoring: 'data monitoring',
	run: 'has been run',
	RAM: 'RAM',
	used: 'used',
	idle: 'idle',
	refresh: 'refresh',
};

export default en;
